import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

import { SeoListComponent } from './seo.list.component';
import { SeoEditComponent } from './seo.edit.component';
import { SeoRouter } from './seo.router';

/** @constant {angular.module} */
const seoModule = angular
  .module('ec.opsCenter.seo', [])
  .config(SeoRouter)
  .directive('appSeoEdit', downgradeComponent({ component: SeoEditComponent }) as angular.IDirectiveFactory)
  .directive('appSeoList', downgradeComponent({ component: SeoListComponent }) as angular.IDirectiveFactory).name;

export default seoModule;



// WEBPACK FOOTER //
// ./src/app/seo/seo.module.ajs.ts